import Swal, {
  type SweetAlertIcon,
  type SweetAlertOptions,
  type SweetAlertResult,
} from 'sweetalert2'
import type { AxiosResponse } from 'axios'

window.showAlert = (
  title: string,
  body: string | HTMLElement | JQuery<HTMLElement> | undefined,
  icon: SweetAlertIcon,
  timer?: number | undefined
) => {
  void Swal.fire({
    toast: true,
    html: body,
    title: title,
    timer: timer || 2000,
    icon: icon,
    width: 300,
    showConfirmButton: false,
  })
}

window.showMessage = (
  title: string,
  body: string | HTMLElement | JQuery<HTMLElement> | undefined,
  icon?: SweetAlertIcon | undefined,
  width?: string | number | undefined
) => {
  return Swal.fire({
    title,
    html: body,
    icon: icon || 'info',
    showConfirmButton: true,
    width: width || 400,
  })
}

function extractContent(htmlString:string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // If body exists → return its inner HTML
  if (doc.body) {
    return abbreviate(doc.body.innerHTML.trim(),100);
  }

  // fallback (rare case)
  return abbreviate(htmlString.trim(),100);
}

function abbreviate(str:string, maxLength:number) {
  return str.length > maxLength
      ? str.slice(0, maxLength) + "..."
      : str;
}

window.showRequestError = (response: AxiosResponse): Promise<SweetAlertResult> => {
  return Swal.fire({
    title: 'Fout',
    html: extractContent(response?.data??response??"Onbekende fout"),
    icon: 'error',
  })
}

window.showDialog = (
  title: string,
  body: string | HTMLElement | JQuery<HTMLElement>,
  icon: SweetAlertIcon,
  width?: number | undefined
) => {
  void Swal.fire({
    title: title,
    html: body,
    icon: icon,
    showConfirmButton: true,
    width: width || 400,
  })
}

window.showDialogPromise = ({
  title,
  text,
  html,
  confirmButtonColor,
  cancelButtonColor,
  confirmButtonText,
  icon,
}: SweetAlertOptions) =>
  Swal.fire({
    title: title,
    text: text,
    html: html,
    icon: icon ?? 'question',
    showCancelButton: true,
    confirmButtonColor: confirmButtonColor,
    cancelButtonColor: cancelButtonColor,
    confirmButtonText: confirmButtonText ?? 'OK',
  })
